module.exports = __webpack_public_path__ + "static/media/help04.b49fe96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/help/help04.png
// module id = 428
// module chunks = 0